'use client';

import { useMemo } from 'react';
import { useTranslations } from 'next-intl';
import {
  TraceGroupByFieldSchema,
  type TraceGroupByField,
} from '@terra/shared-contracts-trace';
import { ListPageGroupByOptionsMenu } from '../../common/ListPageGroupByOptionsMenu';

type ExecutionsViewOptionsMenuProps = {
  groupByField: TraceGroupByField | null;
  onGroupByFieldChange: (field: TraceGroupByField | null) => void;
  areAllGroupsCollapsed: boolean;
  onExpandAllGroups: () => void;
  onCollapseAllGroups: () => void;
};

export function ExecutionsViewOptionsMenu({
  groupByField,
  onGroupByFieldChange,
  areAllGroupsCollapsed,
  onExpandAllGroups,
  onCollapseAllGroups,
}: ExecutionsViewOptionsMenuProps) {
  const tExecutions = useTranslations('designSystem.executions');
  const options = useMemo(() => {
    const fieldLabels: Record<TraceGroupByField, string> = {
      status: tExecutions('columnStatus'),
      agent: tExecutions('filters.agent'),
      result: tExecutions('result'),
    };

    return TraceGroupByFieldSchema.options.map((field) => ({
      value: field,
      label: fieldLabels[field],
    }));
  }, [tExecutions]);

  return (
    <ListPageGroupByOptionsMenu
      options={options}
      groupByField={groupByField}
      onGroupByFieldChange={onGroupByFieldChange}
      areAllGroupsCollapsed={areAllGroupsCollapsed}
      onExpandAllGroups={onExpandAllGroups}
      onCollapseAllGroups={onCollapseAllGroups}
    />
  );
}
